import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const listVistFormBooking = (params: any) => {
  return axios.get(`${API_URL}/vist-form-booking`, { params }).then((res) => res.data);
};


